import React from 'react'
import { cn } from './cn'

// Tailwind replacement for CoreUI's <CProgress>. Same literal-color-map
// pattern as Button/StatTile — see those for why (purge-safety + this
// Tailwind build's reduced default palette, see migration.md).
const COLOR_CLASSES = {
  primary: 'tw-bg-blue-600',
  secondary: 'tw-bg-gray-400',
  success: 'tw-bg-green-600',
  danger: 'tw-bg-red-600',
  warning: 'tw-bg-yellow-500',
  info: 'tw-bg-indigo-500',
  dark: 'tw-bg-gray-800',
}

const Progress = React.forwardRef(
  ({ value = 0, color = 'primary', className, ...props }, ref) => (
    <div
      ref={ref}
      role="progressbar"
      aria-valuenow={value}
      aria-valuemin={0}
      aria-valuemax={100}
      className={cn(
        'tw-h-1.5 tw-w-full tw-overflow-hidden tw-rounded-full tw-bg-gray-200',
        className
      )}
      {...props}
    >
      <div
        className={cn(
          'tw-h-full tw-transition-all',
          COLOR_CLASSES[color] || COLOR_CLASSES.primary
        )}
        style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
      />
    </div>
  )
)
Progress.displayName = 'Progress'

export default Progress
